import PhotoWebAPI from '@api/photo_web_api.js'
import ErrorTypes from '@constants/error_types.js'
import Types from '../types.js'
import {
  handleLoadUserPhotosSuccess,
  handleLoadUserPhotosError,
  handleUploadSuccess,
  handlePhotoDeleteSuccess,
  handleUploadError,
  handlePhotoDeleteError,
} from './server_actions.js'

export const paginateTo = pageNumber => ({
  type: Types.PAGINATE,
  payload: pageNumber,
})

export function loadUserPhotos(pageNumber, apiVersion = 1) {
  return (dispatch, getState) => {
    dispatch(userPhotosRequest(pageNumber))
    PhotoWebAPI.fetchUserPhotos(pageNumber, apiVersion).then(
      res => {
        dispatch(handleLoadUserPhotosSuccess(res, pageNumber))
      },
      err => {
        dispatch(handleLoadUserPhotosError(err, pageNumber))
      }
    )
  }
}

export function uploadPhotos(files, apiVersion = 1) {
  return (dispatch, getState) => {
    dispatch(uploadStart())
    PhotoWebAPI.createPhotos(files, { apiVersion }).then(
      res => {
        dispatch(handleUploadSuccess(res))
      },
      err => {
        if (err.message === ErrorTypes.CALL_ALREADY_IN_PROGRESS) {
          return
        } else {
          dispatch(handleUploadError(err))
        }
      }
    )
  }
}

function uploadStart() {
  return {
    type: Types.PHOTO_UPLOAD_START,
  }
}

export const deletePhoto = (photoId, apiVersion = 1) => {
  return (dispatch, getState) => {
    dispatch(photoDeleteRequest(photoId))
    PhotoWebAPI.deletePhoto(photoId, apiVersion).then(
      res => {
        dispatch(handlePhotoDeleteSuccess(res, photoId))
      },
      err => {
        dispatch(handlePhotoDeleteError(err, photoId))
      }
    )
  }
}

export const photoDeleteRequest = photoId => ({
  type: Types.PHOTO_DELETE_REQUEST,
  payload: photoId,
})

export const userPhotosRequest = pageNumber => ({
  type: Types.USER_PHOTOS_REQUEST,
  payload: {
    pageNumber,
  },
})
